import {
    useCallback,
    useEffect,
    useState
} from 'react';

import {
    BigButton,
    ButtonsGroup,
    TextInput,
    View
} from '../../../common';
import { COLORS } from '../../../styles/colors';

export const DeviceEditForm = ({
    data,
    onSave,
    onCancel,
}) => {
    const [ deviceId, setDeviceId ] = useState('');
    const [ deviceModel, setDeviceModel ] = useState('');
    const [ deviceName, setDeviceName ] = useState('');

    useEffect(() => {
        setDeviceId(data?.deviceId ?? '');
        setDeviceModel(data?.deviceModel ?? '');
        setDeviceName(data?.deviceName ?? '');
    }, [ data ]);

    const onSaveHandler = useCallback(() => {
        onSave?.({
            deviceId,
            deviceModel,
            deviceName,
        });
    }, [ deviceId,
        deviceModel,
        deviceName,
        onSave ]);

    const onCancelHandler = useCallback(() => {
        setDeviceName(data?.deviceName ?? '');
        setDeviceId(data?.deviceId ?? '');
        setDeviceModel(data?.deviceModel ?? '');
        onCancel?.();
    }, [ onCancel,
        setDeviceName,
        setDeviceId,
        setDeviceModel,
        data ]);

    return <View style={{
        borderWidth: 2,
        BorderColor: COLORS.BORDER_GRAY,
        padding: 8,
        margin: 4,
    }}>
        <TextInput
            value={deviceId}
            onChange={setDeviceId}
            placeholder={'Device id'}
            disabled
        />
        <TextInput
            value={deviceModel}
            onChange={setDeviceModel}
            placeholder={'Device model'}
        />
        <TextInput
            value={deviceName}
            onChange={setDeviceName}
            placeholder={'Device name'}
        />
        <ButtonsGroup>
            <BigButton
                title={'Сохранить'}
                action={onSaveHandler}/>
            <BigButton
                title={'Отменить'}
                action={onCancelHandler}/>
        </ButtonsGroup>
    </View>;
};
